import React from "react";

type DemoResponseProps = {
  isVisible: boolean;
  words: string[];
};

function DemoResponse({ isVisible, words }: DemoResponseProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="animate-fade-in main:w-[70%]">
      <div className="flex items-start gap-5">
        <div className="tablet:pl-[86px] main:pl-[138px]">
          <div className="rounded-2xl bg-primary-dark px-5 py-4 font-light text-white">
            {words.map((word, index) => (
              <span
                key={`${word}-${index}`}
                className="animate-fade-in transition-all"
              >
                {`${word}\u00A0`}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DemoResponse;
